import { LoginForm } from "../../../sections/auth/login";
import AuthLayout from "src/layouts/auth";

const LoginPage = () => {
  return (
    <AuthLayout title="Login">
      <LoginForm />
    </AuthLayout>
  );
};

export default LoginPage;
